import { Route } from 'react-router-dom';
import React, { Component } from 'react';
import '../css/notfound.css'

export default class NotFound extends Component {
	componentDidMount(){
		document.body.style.backgroundImage = "url('../img/notfound/BACKGROUND.jpg')";
		document.getElementsByClassName("medallaRMP")[0].style.display = "none"
	}
	componentWillUnmount(){
		document.getElementsByClassName("medallaRMP")[0].style.display = "block"
	}
	render() {
		console.log(this.props.location.pathname);
		return (
			<Route render={({ staticContext }) => {
				if (staticContext) {
					staticContext.status = 404;
				}
				return (
					<div className="not-found">
						<img
							src="../../img/notfound/FONDO-DE-ERROR.jpg"
							alt="notfound"
						/>
					</div>
				)
			}}/>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/notfound.js